/**
 * Formats an ABN number into the standard format (XX XXX XXX XXX)
 * @param {string} value - The ABN to format
 * @returns {string} - Formatted ABN
 */
export const formatABN = (value) => {
  if (!value) return '';
  // Remove all non-digit characters
  const numbers = value.replace(/\D/g, '');
  // Format as XX XXX XXX XXX
  return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
};

/**
 * Validates an ABN number according to the official ABN validation algorithm
 * @param {string} abn - The ABN to validate
 * @returns {boolean} - Whether the ABN is valid
 */
export const validateABN = (abn) => {
  // Remove any spaces or non-digit characters
  const cleanABN = abn.replace(/\s/g, '');
  
  // Check if it's exactly 11 digits
  if (!/^\d{11}$/.test(cleanABN)) {
    return false;
  }

  // Convert to array of digits
  const digits = cleanABN.split('').map(Number);
  
  // Apply ABN validation algorithm
  // 1. Subtract 1 from the first digit
  digits[0] -= 1;
  
  // 2. Multiply each digit by its weight
  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  const sum = digits.reduce((acc, digit, index) => acc + (digit * weights[index]), 0);
  
  // 3. Check if sum is divisible by 89
  return sum % 89 === 0;
}; 